import Vue from "vue";
import VueI18n from "vue-i18n";
import { createI18n, castToVueI18n } from "vue-i18n-bridge";
import { detectUserLocale, LOCALE_CONFIG } from "../utils/i18n/locale";

// 翻訳ファイルのインポート
import ja from "./ja.json";
import en from "./en.json";
import zhTW from "./zh-TW.json";
import zhCN from "./zh-CN.json";
import ko from "./ko.json";

// 型定義
interface LocaleChangedEvent extends CustomEvent {
  detail: {
    previous: string;
    current: string;
  };
}

interface TranslationMessages {
  [key: string]: any;
}

// vue-i18nをVueプラグインとして登録（bridgeモード有効化）
Vue.use(VueI18n, { bridge: true });

// 翻訳メッセージをマッピング
const messages: Record<string, TranslationMessages> = {
  ja,
  en,
  "zh-TW": zhTW,
  "zh-CN": zhCN,
  ko,
};

// vue-i18n-bridgeでi18nインスタンスを作成
// TypeScriptの場合、castToVueI18nが必要
const i18n = castToVueI18n(
  createI18n(
    {
      legacy: false, // Composition API モード有効化
      globalInjection: true, // Options APIでも$tなどを使用可能にする
      locale: detectUserLocale(), // 動的な言語検出
      fallbackLocale: LOCALE_CONFIG.DEFAULT_LOCALE,
      messages,
      // 警告設定
      silentTranslationWarn: process.env.NODE_ENV === "production", // 本番環境では翻訳が見つからない場合の警告を抑制
      silentFallbackWarn: process.env.NODE_ENV === "production", // 本番環境ではフォールバック警告を抑制
    },
    VueI18n // VueI18nコンストラクタを渡す
  )
);

// createI18nで作成したインスタンスをVueプラグインとして登録
// Vue.use(i18n)を呼ぶことで、Options APIで$tが使えるようになる
Vue.use(i18n);

// 言語変更時のイベントリスナー
window.addEventListener("localeChanged", (event: Event) => {
  try {
    const customEvent = event as LocaleChangedEvent;
    const { current } = customEvent.detail;
    // VueI18nインスタンスのlocaleを直接設定
    i18n.locale = current;
  } catch (error) {
    console.error("Failed to update locale:", error);
  }
});

// main.tsでnew Vue({ i18n })に渡すためのエクスポート
export default i18n;
